export default "__VITE_ASSET__DotzwWGB__"